/* eslint-disable i18next/no-literal-string -- css not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

export const dialog = defineSlotRecipe({
  slots: ['backdrop', 'positioner', 'content', 'header', 'body', 'footer', 'title', 'description'],
  className: 'chakra-dialog',
  base: {
    header: {
      py: 4,
    },
    body: {
      py: '2',
    },
    footer: {
      py: '4',
    },
    title: {
      textStyle: 'xl',
    },
    description: {
      color: 'fg',
    },
  },

  variants: {
    size: {
      '4xl': {
        content: {
          maxW: '4xl',
        },
      },
    },
  },
});
